//  Time Left
 
 $(document).ready(function(){
          
        var clock = document.getElementById('clockdiv');
        var mega = {};
        mega.endTime = false;
          
        var countDown = {
          days: clock.querySelector('.days'),
          hours: clock.querySelector('.hours'),
          minutes: clock.querySelector('.minutes'),
          seconds: clock.querySelector('.seconds'),
          getMins: function(time) {
            var stamp = new Date("November 1, 2020 " + time);
            return (stamp.getHours() * 60 + stamp.getMinutes())
          },
          getNowUser: function() {
            var nowUser = new Date().toLocaleString("en-US", {timeZone: "America/Los_Angeles"});
            return new Date(nowUser);
          },
          getEndTime: function() {
            var now = this.getNowUser();
            var endTime;
            mega.hour = now.getHours();
            mega.minutes = now.getMinutes();
            var nowMins = (mega.hour * 60) + mega.minutes;
            
            // this is the main window
            if (nowMins >= mega.start && nowMins < mega.end) {
              endTime = new Date("November 1, 2020 11:59 pm");
                                 
            // this is before the start
            } else if (nowMins < mega.start){
              endTime = new Date("November 1, 2020 12:00 am");
                                 
            // this is after the end
            } else if (nowMins >= mega.end) {
              now.setDate(now.getDate() + 1);
              endTime = new Date("November 1, 2020 12:00 am");
            }
            
            // now this becomes the new endTime
            return new Date(now.getFullYear(), now.getMonth(), now.getDate(), endTime.getHours(), endTime.getMinutes());
          },
          getTimeRemaining: function(){
            var now = this.getNowUser();
            if (mega.endTime === false || now >= mega.endTime) {
              mega.endTime = this.getEndTime();
            }
            
            var total = Date.parse(mega.endTime) - Date.parse(now);
            var seconds = Math.floor( (total/1000) % 60 );
            var minutes = Math.floor( (total/1000/60) % 60 );
            var hours = Math.floor( (total/(1000*60*60)) % 24 );
            var days = Math.floor( total/(1000*60*60*24) );

            return {
              total,
              days,
              hours,
              minutes,
              seconds
            };
          },         
          updateClock: function(){
            var t = this.getTimeRemaining();
            if (t.days) {
              this.days.innerHTML = ('0' + t.days).slice(-2) + ':';
              this.days.classList.remove('hidden');
            } else {
              if (!this.days.classList.contains('hidden')) this.days.classList.add('hidden');
            }
            this.hours.innerHTML = ('0' + t.hours).slice(-2);
            this.minutes.innerHTML = ('0' + t.minutes).slice(-2);
            this.seconds.innerHTML = ('0' + t.seconds).slice(-2);
          },
        }
        
        // this code inits the start and end times
        mega.start = countDown.getMins("12:00 am");
        mega.end = countDown.getMins("11:59 pm");        
              
        // this code runs the clock and updates the timer
        var megaTimer2 = setInterval(function(){
          countDown.updateClock();
        }, 1000);
          
        window.cartBus.on('product-selected-done', function(){
          /*if (!stillValid()) {
            saleOver();
          }*/
        });        
        $('.product-time-left').fadeTo(1000, 1);
  
      });